import { Component, Input } from '@angular/core';
import { SummaryItem } from '../../../models';

@Component({
  selector: 'app-report-footer-columns',
  templateUrl: './report-footer-columns.component.html',
  styleUrl: './report-footer-columns.component.scss',
})
export class ReportFooterColumnsComponent {
  @Input() summaryItems: SummaryItem[][];
}
